module.exports = "/images/wordpress.png?caa5cdad79ef064893fcbd5131718bb8";